var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"esi",class:{'esi--invisible': !_vm.visible}},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validation),expression:"validation"}],ref:"input",staticClass:"esi__input",class:{
        'esi__input--invisible': !_vm.visible,
        'esi__input--valid': _vm.valid,
        'esi__input--error': _vm.error,
        'esi__input-dark': _vm.darkTheme
        },attrs:{"name":_vm.getName,"type":_vm.type},domProps:{"value":_vm.value},on:{"focus":function($event){return _vm.focus()},"blur":function($event){return _vm.blur()},"input":function($event){return _vm.emit()},"keyup":function($event){return _vm.keyup()}}}),(_vm.label)?_c('label',{staticClass:"esi__label",class:{
           'esi__label--focus': _vm.focus,
           'esi__label--filled': _vm.value.length,
           'esi__label--valid': _vm.valid,
           'esi__label--error': _vm.error,
           'esi__label--invisible': _vm.hideLabel
           }},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }